// BT-53 (P41) -- the Board's pen settings: the colour and the width of what
// the student draws next. The four colours are the approved Board Workspace
// prototype's own (`COLORS = [INK, '#314bd6', '#d14545', '#1f8a4c']`, its
// «رنگ قلم» control); the three widths are Excalidraw's own stroke presets,
// with the Board's existing default (2) in the middle. The owner approved
// the width control as an addition to the prototype (P41 DEV-1).
//
// A setting is Excalidraw's `currentItemStrokeColor` / `currentItemStrokeWidth`:
// it applies to the elements drawn after it, never to what is already on the
// board, and it travels in each element's own `strokeColor` / `strokeWidth`
// (Subway's scene validator already accepts both).

export const PEN_COLORS = Object.freeze([
  Object.freeze({ key: 'ink', value: '#0b163f' }),
  Object.freeze({ key: 'blue', value: '#314bd6' }),
  Object.freeze({ key: 'red', value: '#d14545' }),
  Object.freeze({ key: 'green', value: '#1f8a4c' }),
])

export const PEN_WIDTHS = Object.freeze([
  Object.freeze({ key: 'thin', value: 1 }),
  Object.freeze({ key: 'medium', value: 2 }),
  Object.freeze({ key: 'thick', value: 4 }),
])

export const DEFAULT_PEN_STYLE = Object.freeze({
  color: PEN_COLORS[0].value,
  width: PEN_WIDTHS[1].value,
})

/**
 * A pen style the editor can apply: anything outside the two lists falls
 * back to the default of that part.
 * @param {{color?: string, width?: number}|null|undefined} style
 * @returns {{color: string, width: number}}
 */
export function normalizePenStyle(style) {
  const color =
    style && PEN_COLORS.some(entry => entry.value === style.color)
      ? style.color
      : DEFAULT_PEN_STYLE.color
  const width =
    style && PEN_WIDTHS.some(entry => entry.value === style.width)
      ? style.width
      : DEFAULT_PEN_STYLE.width
  return { color, width }
}
